const isLocalHost = window.location.hostname === 'localhost';

export default isLocalHost;
